import React from 'react'

import {createSvgIcon} from './utils'

export default createSvgIcon(
  <>
    <rect height="12" rx="0.428561" width="3" x="6" y="6" />
    <rect height="12" rx="0.428561" width="7" x="15" y="6" />
    <rect height="12" rx="0.428561" width="2" x="2" y="6" />
    <rect height="12" rx="0.428561" width="2" x="11" y="6" />
  </>,
  'BarcodeIcon',
)
